import React from "react"

export enum DividerTypeEnum {
  vertical = "vertical",
  horizontal = "horizontal",
}
interface DividerProps {
  className?: string
  type?: DividerTypeEnum
}

const Divider = ({ className, type = DividerTypeEnum.horizontal }: DividerProps) => {
  return type === "vertical" ? (
    <div className={`h-auto w-0.5 self-stretch bg-[#D9D9D9] ${className}`} />
  ) : (
    <div className={`w-full h-px bg-neutral-200 ${className}`} />
  )
}

export default Divider
